import axios from "axios";
import auth from "./auth";

export const LANGUAGE_OPTIONS = [
  "american",
  "german",
  "french",
  "dutch",
  "russian",
  "italian",
  "polish",
  "hungarian",
  "chinese_simplified",
  "swedish",
  "japanese",
  "norwegian",
  "korean",
  "spanish",
  "danish",
  "vietnamese",
  "chinese_traditional",
];

type SimpleOp = "<" | "<=" | ">" | ">=" | "!=" | "==";
type CombinedOp = "and" | "or";
export type Op = SimpleOp | CombinedOp;

export type RuleField = "roonVersion" | "roonPlatform" | "roonProduct";

export interface SimpleRule {
  op: SimpleOp;
  field: RuleField;
  value: string;
}

export interface CombinedRule {
  op: CombinedOp;
  rules: Rule[];
}

export type Rule = SimpleRule | CombinedRule;

export function isSimpleRule(rule: Rule): rule is SimpleRule {
  return (rule as SimpleRule).field !== undefined;
}

export function isCombinedOp(op: Op): op is CombinedOp {
  return ["and", "or"].includes(op);
}

export interface Message {
  id?: string;
  userId: string;
  type: "hero" | "inbox";
  template: Template;
  userData?: any;
  createdAt?: string;
  expiresAt?: string;
  tags?: string[];
  clearMessagesWithTags?: string[];
  status?: "delivered" | "seen" | "engaged";
  rules?: Rule;
}

export interface Template {
  title: string;
  body: string;
  ctaText?: string;
  ctaUrl?: string;
}

async function loadMessages(userId: string): Promise<Message[]> {
  const { data } = await auth.authenticateRequest(
    "get",
    `/2/api/messages/${userId}`
  );
  return data.messages;
}

async function revokeMessage(userId: string, messageId: string) {
  await auth.authenticateRequest(
    "delete",
    `/2/api/messages/${userId}/${messageId}`
  );
}

async function registerEngagement(
  userId: string,
  messageId: string,
  event: string
) {
  await auth.authenticateRequest(
    "post",
    `/2/api/messages/${userId}/${messageId}/${event}`
  );
}

async function sendMessage(message: Message, token: string) {
  await axios.post(`/2/api/messages`, message, {
    headers: { authorization: `Bearer ${token}` },
  });
}

export default {
  loadMessages,
  revokeMessage,
  registerEngagement,
  sendMessage,
};
